import { Switch, useHistory } from 'react-router-dom'
import RouteMiddleware from 'src/components/common/RouteMiddleware'
import UserDetails from 'src/components/BuyPolicy/insuranceScreens/health/UserDetails'
import Header from 'src/components/BuyPolicy/common/Header'
import Footer from 'src/components/BuyPolicy/common/Footer'
import HealthInsuranceDetailsLayout from 'src/components/BuyPolicy/layout/HealthInsuranceDetailsLayout'
import Motor from 'src/components/BuyPolicy/insuranceScreens/motor'
import MotorInsuranceDetailsLayout from 'src/components/BuyPolicy/layout/MotorInsuranceDetailsLayout'
import PaymentSuccess from 'src/components/BuyPolicy/common/PaymentSuccess'
import PaymentFailure from 'src/components/BuyPolicy/common/PaymentFailure'
import KycComplete from 'src/components/BuyPolicy/common/KycComplete'
import Payment from 'src/components/BuyPolicy/common/Payment'
import { getUrlLastRoute } from 'src/utils/commonMethods'
import KycStatus from 'src/components/BuyPolicy/common/KycStatus'
import { useEffect, useState } from 'react'
import KycFailure from 'src/components/BuyPolicy/common/KycFailure'
import BikeInsuranceDetailsLayout from 'src/components/BuyPolicy/layout/BikeInsuranceDetailsLayout'
import Bike from 'src/components/BuyPolicy/insuranceScreens/bike'
import TermsAndConditionsPrivacyPolicy from 'src/components/BuyPolicy/insuranceScreens/health/TermsAndConditionsPrivacyPolicy'
import VerifyPaymentStatus from 'src/components/BuyPolicy/common/VerifyPaymentStatus'
import LifeUserDetails from 'src/components/BuyPolicy/insuranceScreens/life/LifeUserDetails'
import LifeInsuranceLayout from 'src/components/BuyPolicy/layout/LifeInsuranceLayout'
import { KYC, PAYMENT } from 'src/utils/constants/BuyPolicy'

const BuyPolicyLayout = ({ isHeaderHidden }) => {
  const [showHeader, setShowHeader] = useState(true)
  const [showFooter, setShowFooter] = useState(true)

  const history = useHistory()

  useEffect(() => {
    const unlisten = history.listen(() => {
      // Handle route change here
      const urlLastRoute = getUrlLastRoute()
      if (urlLastRoute === PAYMENT || urlLastRoute === KYC) {
        setShowHeader(false)
        setShowFooter(false)
      } else {
        setShowHeader(true)
        setShowFooter(true)
      }
    })

    // The `unlisten` function returned by `history.listen` will stop the listener when the component unmounts
    return () => {
      unlisten()
    }
  }, [history])

  return (
    <>
      {!isHeaderHidden && showHeader ? <Header /> : null}
      <Switch>
        <RouteMiddleware
          title={'Health Individual Registration'}
          path='/individual/dashboard/buyPolicy/health'
          exact
          component={UserDetails}
        />
        <RouteMiddleware
          title={'Health Insurance Details'}
          path='/individual/dashboard/buyPolicy/health/insuranceDetails'
          component={HealthInsuranceDetailsLayout}
        />
        <RouteMiddleware
          title={'Motor User Registration'}
          path='/individual/dashboard/buyPolicy/motor'
          exact
          component={Motor}
        />
        <RouteMiddleware
          title={'Motor Insurance Details'}
          path='/individual/dashboard/buyPolicy/motor/insuranceDetails'
          component={MotorInsuranceDetailsLayout}
        />
        <RouteMiddleware
          title={'Bike User Registration'}
          path='/individual/dashboard/buyPolicy/bike'
          exact
          component={Bike}
        />

        <RouteMiddleware
          title={'Bike Insurance Details'}
          path='/individual/dashboard/buyPolicy/bike/insuranceDetails'
          component={BikeInsuranceDetailsLayout}
        />
        <RouteMiddleware
          title={'Life User Registration'}
          path='/individual/dashboard/buyPolicy/life'
          exact
          component={LifeUserDetails}
        />
        <RouteMiddleware
          title={'Life Insurance Details'}
          path='/individual/dashboard/buyPolicy/life/insuranceDetails'
          component={LifeInsuranceLayout}
        />
        <RouteMiddleware
          title={'Payment Success'}
          path='/individual/dashboard/buyPolicy/payment'
          component={Payment}
        />
        <RouteMiddleware
          title={'Payment Success'}
          path='/individual/dashboard/buyPolicy/verify-payment-status'
          component={VerifyPaymentStatus}
        />
        <RouteMiddleware
          title={'Payment Success'}
          path='/individual/dashboard/buyPolicy/payment-status/success'
          component={PaymentSuccess}
        />
        <RouteMiddleware
          title={'Payment Failure'}
          path='/individual/dashboard/buyPolicy/payment-status/failure'
          component={PaymentFailure}
        />
        <RouteMiddleware
          title={'Kyc Status'}
          path='/individual/dashboard/buyPolicy/kyc'
          component={KycStatus}
          exact
        />
        <RouteMiddleware
          title={'Kyc Complete'}
          path='/individual/dashboard/buyPolicy/payment-status/kyc-complete'
          component={KycComplete}
        />
        <RouteMiddleware
          title={'Kyc Complete'}
          path='/individual/dashboard/buyPolicy/payment-status/kyc-failed'
          component={KycFailure}
        />
        <RouteMiddleware
          title={'Terms And Conditions'}
          path='/individual/dashboard/buyPolicy/terms-conditions-privacy-policy'
          component={TermsAndConditionsPrivacyPolicy}
        />
      </Switch>
      {showFooter ? <Footer /> : null}
    </>
  )
}

export default BuyPolicyLayout
